import React, { useState } from "react";
import get from "lodash/get";
import excelIcon from "../../assets/images/icons/excel-icon.svg";
import { api as apiService, queryBuilder } from "../../services";
import Spinner from "../Spinner";
import useTranslation from "hooks/useTranslation";
import useAlert from "hooks/useAlert";

const EXCEL_MIME =
	"application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

const normalizeExcelFilename = name => {
	const base = (name || "download").trim();
	if (/\.xlsx$/i.test(base)) {
		return base;
	}
	const withoutSuffix = base.replace(/\s*xlsx\s*$/i, "").trim();
	return `${withoutSuffix || "download"}.xlsx`;
};

const getFilenameFromHeaders = headers => {
	const disposition = get(headers, "content-disposition", "");
	const utf8Match = disposition.match(/filename\*=UTF-8''([^;]+)/i);
	if (utf8Match?.[1]) {
		return decodeURIComponent(utf8Match[1]);
	}
	const match = disposition.match(/filename="?([^";]+)"?/i);
	return match?.[1] ? match[1].trim() : null;
};

const Index = ({ filename, api, params }) => {
	const [isSubmitting, setSubmitting] = useState(false);
	const { tr } = useTranslation();
	const { showAlert } = useAlert();

	const downloadFile = async () => {
		setSubmitting(true);
		try {
			const response = await apiService.request.get(
				queryBuilder(api, params),
				{
					responseType: "blob",
				}
			);

			const contentType = get(response, "headers.content-type", "");
			const blobData = response.data;

			if (
				contentType.includes("application/json") ||
				contentType.includes("text/plain")
			) {
				const text = await blobData.text();
				let message = tr("Ошибка при экспорте файла");
				try {
					const json = JSON.parse(text);
					message = get(json, "message", message);
				} catch {
					if (text) message = text;
				}
				throw new Error(message);
			}

			const downloadName = normalizeExcelFilename(
				getFilenameFromHeaders(response.headers) || filename
			);

			const blob = new Blob([blobData], {
				type: contentType.includes("sheet") || contentType.includes("excel")
					? contentType
					: EXCEL_MIME,
			});

			const url = window.URL.createObjectURL(blob);
			const link = document.createElement("a");
			link.href = url;
			link.setAttribute("download", downloadName);
			document.body.appendChild(link);
			link.click();
			link.parentNode.removeChild(link);
			window.URL.revokeObjectURL(url);
		} catch (error) {
			console.error("Error downloading the file:", error);
			showAlert(
				get(error, "response.data.message") ||
					get(error, "message") ||
					tr("Ошибка при экспорте файла"),
				{ type: "danger" }
			);
		} finally {
			setSubmitting(false);
		}
	};

	return (
		<div
			className="download-to-excel-btn ml-10"
			onClick={() => {
				if (!isSubmitting) {
					downloadFile();
				}
			}}
		>
			<img src={excelIcon} alt="" width="50px" height="50px" />
			{tr("Скачать нa EXCEL")}
			{isSubmitting && <Spinner sm />}
		</div>
	);
};

export default Index;
